module.exports = __webpack_public_path__ + "img/icon-line - w.e789f116.svg";